// Routes — URL historiques : LES redirections héritées (table routes/redirections.ts)
// et les chemins canoniques /admin/* conservés pour les signets.
// Lot 7.6 (2026-10-17) : App.tsx éclaté par domaine, aucune URL changée.
// Lot 9.0 (2026-10-18) : les quarante redirections écrites à la main dans cinq
// fichiers de routes (quatre formes : <Navigate> nu, RedirectAvecQuery, trois
// composants à paramètres) deviennent UNE table, rendue ici en lot par
// `routesRedirectionsHeritees()` — chaque entrée documente son motif, le
// garde-fou `check-urls-heritees` vérifie qu'aucune ancienne URL n'est perdue.
import { lazy, Suspense } from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "../components/ProtectedRoute";
import { LoadingFallback, RedirectionHeritee } from "./communs";
import { REDIRECTIONS_HERITEES } from "./redirections";

export const MesCommunicationsPage = lazy(() => import("../pages/MesCommunicationsPage"));
export const FacturationFormateurPage = lazy(() => import("../pages/FacturationFormateurPage"));
export const QuestionnairesParticipantPage = lazy(() => import("../pages/QuestionnairesParticipantPage"));

/** Une <Route> par ancienne URL de la table — jamais une redirection écrite à la main ailleurs. */
function routesRedirectionsHeritees() {
  return (
    <>
      {REDIRECTIONS_HERITEES.map((entree) => (
        <Route key={entree.de} path={entree.de} element={<RedirectionHeritee entree={entree} />} />
      ))}
    </>
  );
}

export function routesHistoriques() {
  return (
    <>
      {routesRedirectionsHeritees()}

      {/* Fusion espace-formateur finie (lot résorption 2026-08-06) : la page
          de facturation animateur ne vit qu'à l'URL canonique admin (même
          composant, menu QW5). Lot 9.5 : la validation et la conformité des
          documents animateurs sont des onglets de /o/:slug/animateurs. */}
      <Route
        path="/plateforme/remuneration"
        element={
          <ProtectedRoute requiredRoles={["SUPER_ADMIN", "PILOTE"]} orgPlateformeOnly>
            <Suspense fallback={<LoadingFallback />}>
              <FacturationFormateurPage />
            </Suspense>
          </ProtectedRoute>
        }
      />

      {/* Espace Participant — pages servies sous l'accueil personnel */}
      <Route
        path="/mon-espace/questionnaires"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingFallback />}>
              <QuestionnairesParticipantPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/mon-espace/echanges"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingFallback />}>
              <MesCommunicationsPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
    </>
  );
}
